import secureStorage from "react-secure-storage";
import { LocaleStorageKeys } from "./localstorage.types";

export type LocaleStorageValue = string | object | number | boolean;

export interface SecureStorageAdapter {
  getItem: (key: string) => LocaleStorageValue | null;
  setItem: (key: string, value: LocaleStorageValue) => void;
  removeItem: (key: string) => void;
  clear: () => void;
}

export class LocaleStorageManager {
  constructor(private readonly storage: SecureStorageAdapter = secureStorage) {}

  get(key: LocaleStorageKeys) {
    return this.storage.getItem(key);
  }

  set(key: LocaleStorageKeys, value: LocaleStorageValue) {
    this.storage.setItem(key, value);
  }

  setIdentityToken(token: string) {
    this.set(LocaleStorageKeys.IDENTITY_TOKEN, token);
  }

  getIdentityToken() {
    return this.get(LocaleStorageKeys.IDENTITY_TOKEN);
  }

  removeIdentityToken() {
    this.storage.removeItem(LocaleStorageKeys.IDENTITY_TOKEN);
  }

  clear(keysToPreserve: readonly LocaleStorageKeys[] = []) {
    const preservedValues = new Map<LocaleStorageKeys, LocaleStorageValue>();

    keysToPreserve.forEach(key => {
      try {
        const value = this.get(key);

        if (value !== null) preservedValues.set(key, value);
      } catch {
        // A storage read failure must not prevent logout or authentication cleanup.
      }
    });

    this.storage.clear();

    preservedValues.forEach((value, key) => {
      try {
        this.set(key, value);
      } catch {
        // A restore failure must not prevent logout or authentication cleanup.
      }
    });
  }
}
